import {StandardDialogFooter} from "../../../../pages/components/dialogs/standard-dialog/standard-dialog";
import React, {useState} from "react";
import {DialogContent, Grid} from "@mui/material";
import {BarekamSelect} from "../../../../pages/components/select/select";
import {BarekamMenuItem, SelectedBarekamMenuItem} from "../../../../pages/components/select/styled/orders";
import BarekamInput from "../../../../pages/components/input";
import {useAppSelector} from "../../../../redux/store";
import {Message, MessageSections} from "../../../../pages/components/message/message";
import {AxiosError} from "axios";
import {mapValidationErrors} from "../../../../pages/user/settings/personal-info/personal-info.service";
import {MessageModel} from "../../../../pages/shared/models/message.model";
import messagesService from "../../../../services/messages.service";
import {supportedLanguages} from "../../../../constants";
import {getMessage} from "../../../../pages/shared/helper-functions";

const messageSections = [
    MessageSections.MAIN,
    MessageSections.LOGIN,
    MessageSections.ORDERS,
    MessageSections.USER,
    MessageSections.PROHIBITED,
    MessageSections.CALCULATE
]

const NewMessage = ({onCancel, predefinedMessage}: NewMessageDialogProps) => {
    const [message, setMessage] = useState(predefinedMessage || {
        key: '',
        name: '',
        section: '',
    } as MessageModel)
    const [names, setNames] = useState(predefinedMessage ? JSON.parse(predefinedMessage.name) : {});

    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    const {messageCache, languageId} = useAppSelector(state => state.messagesReducer);

    function onChange(field: 'name' | 'key' | 'section' | number, value: any) {
        if (typeof field === 'number') {
            setNames((prevState: {[key: number]: string}) => {
                prevState[field] = value;
                return {...prevState};
            })
        } else {
            setMessage(prevState => {
                prevState[field] = value;
                return {...prevState};
            })
        }
    }

    function validateMessage() {
        const errors = {} as {[key: string]: string};

        supportedLanguages.forEach((abbr, index) => {
            if (!names[index + 1]) {
                errors[`name_${abbr}`] = 'required';
            }
        });

        if (!message.key) {
            errors['key'] = 'required';
        }
        if (!message.section) {
            errors['section'] = 'required';
        }

        return errors;
    }

    function handleSave() {
        const errors = validateMessage();
        setErrors(errors);

        if (Object.keys(errors).length === 0 && message) {
            const jsonNames = JSON.stringify(names);

            if (message.messageId) {
                messagesService.editMessage(message.messageId, {...message, name: jsonNames})
                    .then((response: any) => {
                        if (response) {

                            onCancel();
                        }
                    })
                    .catch(e => {
                        if (e instanceof AxiosError) {
                            setErrors(mapValidationErrors(e));
                        }
                    });
            } else {
                messagesService.addMessage({...message, name: jsonNames})
                    .then((response: any) => {
                        if (response) {

                            onCancel();
                        }
                    })
                    .catch(e => {
                        if (e instanceof AxiosError) {
                            setErrors(mapValidationErrors(e));
                        }
                    });
            }
        }
    }

    return (
        <>
            <DialogContent>
                <Grid container rowSpacing={'1rem'} columnSpacing={'1rem'}>
                    <Grid item xs={12}>
                        <BarekamInput key={'key'}
                                      customInputVariant={"standard"}
                                      placeholder={getMessage('message_key', MessageSections.MAIN, messageCache, languageId)}
                                      value={message.key}
                                      onChange={(event) => onChange('key', event.target.value)}
                                      error={!!errors['key']}
                                      errorMessage={errors['key'] && getMessage(errors['key'], MessageSections.MAIN, messageCache, languageId)}
                                      width={'100%'}/>
                    </Grid>

                    {supportedLanguages.map((abbr, index) => {
                        const key = `name_${abbr}`;

                        return (
                            <Grid item xs={12}>
                                <BarekamInput key={key}
                                              customInputVariant={"standard"}
                                              placeholder={getMessage(key, MessageSections.MAIN, messageCache, languageId)}
                                              value={names[index + 1]}
                                              onChange={(event) => onChange(index + 1, event.target.value)}
                                              error={!!errors[key]}
                                              errorMessage={errors[key] && getMessage(errors[key], MessageSections.MAIN, messageCache, languageId)}
                                              width={'100%'}/>
                            </Grid>
                        )
                    })}

                    <Grid item xs={12}>
                        <BarekamSelect
                            variant={'outlined'}
                            label={getMessage('message_section', MessageSections.MAIN, messageCache, languageId)}
                            value={message.section || ''}
                            onChange={(value) => onChange('section', value.target.value)}
                            type={"standard"}
                            error={!!errors['section']}
                            errorMessage={errors['section'] && getMessage(errors['section'], MessageSections.MAIN, messageCache, languageId)}>
                            {messageSections.map((sectionId, index) => {
                                if (message.section === sectionId) {
                                    return (
                                        <SelectedBarekamMenuItem value={sectionId}
                                                                 key={index}>
                                            {sectionId}
                                        </SelectedBarekamMenuItem>
                                    )
                                } else {
                                    return (
                                        <BarekamMenuItem value={sectionId}
                                                         key={index}>
                                            {sectionId}
                                        </BarekamMenuItem>
                                    );
                                }
                            })}
                        </BarekamSelect>
                    </Grid>
                </Grid>
            </DialogContent>

            <StandardDialogFooter onCancel={() => onCancel()}
                                  onSave={() => handleSave()}
                                  saveLabel={<Message messageKey={message.messageId ? 'save' : 'create'} sectionId={MessageSections.ORDERS}/>}/>
        </>
    );
}

interface NewMessageDialogProps {
    onCancel: () => void,
    predefinedMessage?: MessageModel
}

export default NewMessage;